var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"select-the-class"},_vm._l((_vm.tabs),function(item){return _c('div',{key:item.key,class:{active: item.key === _vm.activeKey},on:{"click":function($event){return _vm.handleClick(item.key)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }